import { render, staticRenderFns } from "./SideMenuItem.vue?vue&type=template&id=07b123ff"
import script from "./SideMenuItem.vue?vue&type=script&lang=js"
export * from "./SideMenuItem.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports